"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rows = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.Rows = function (_a) {
    var _b, _c;
    var colorPalette = _a.colorPalette, className = _a.className, width = _a.width, height = _a.height;
    var odd = (_b = colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.odd) !== null && _b !== void 0 ? _b : "#D7DCE1";
    var even = (_c = colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.even) !== null && _c !== void 0 ? _c : "#798795";
    return (react_1.default.createElement("svg", { className: className, width: width !== null && width !== void 0 ? width : 16, height: height !== null && height !== void 0 ? height : 16, viewBox: "0 0 12 11", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { transform: "translate(-519.000000, -212.000000)" },
                react_1.default.createElement("g", { transform: "translate(244.000000, 165.000000)" },
                    react_1.default.createElement("g", { transform: "translate(259.500000, 33.000000)" },
                        react_1.default.createElement("g", { transform: "translate(15.500000, 14.000000)" },
                            react_1.default.createElement("g", null,
                                react_1.default.createElement("rect", { fill: odd, x: "0", y: "2.26485497e-14", width: "12", height: "2.2" }),
                                react_1.default.createElement("rect", { fill: even, x: "0", y: "2.93333333", width: "12", height: "2.2" }),
                                react_1.default.createElement("rect", { fill: odd, x: "0", y: "5.86666667", width: "12", height: "2.2" }),
                                react_1.default.createElement("rect", { fill: even, x: "0", y: "8.8", width: "12", height: "2.2" })))))))));
};
//# sourceMappingURL=Rows.js.map